import { connect } from 'react-redux';
import { updateField } from '../actions/FormActions';
import ModalOption from '../components/ModalOption';
import { Modal } from 'bootstrap';

const getModalOption = (field, option, disabledOptions, blank_label) => {
  return {
    fieldName: field.name,
    optionName: option.displayName,
    optionValue: option.value,
    price: option.price,
    image: option.image,
    isSelected: isSelected(option.value, field.value),
    isDisabled: isDisabled(option.value, disabledOptions),
    isBlankOption: blank_label,
  };
};

function isSelected(optionValue, fieldValue) {
  return optionValue === fieldValue;
}

function isDisabled(optionValue, disabledOptions) {
  return disabledOptions.indexOf(optionValue) > -1;
}

const mapStateToProps = (state, ownProps) => {
  return getModalOption(ownProps.field, ownProps.option, ownProps.disabledOptions, ownProps.blank_label);
};

const mapDispatchToProps = (dispatch, ownProps) => {
  let modalId = ownProps.modalId;
  return {
    optionClickHandler: (name, value) => {
      dispatch(updateField(name, value));
      const modalEl = document.getElementById(modalId);
      if (modalEl) {
        Modal.getOrCreateInstance(modalEl).hide();
      } else {
        console.error('Modal element not found:', modalId);
      }
    }
  };
};

const ModalOptionContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalOption);

export default ModalOptionContainer;
